module.exports = __webpack_public_path__ + "static/img/btn_chenggong_nor@2x.ae746f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/IdentitAuthentication/images/btn_chenggong_nor@2x.png
// module id = ezwN
// module chunks = 1